import { blogs, images } from "../../Components/BlogLogic/BlogLogic";
import { useNavigate } from "react-router-dom";
import React, { useEffect } from 'react';
import Testimonial from "../Testimonials/Testimonial";
import { blogBg } from "../../../../../images";
import SEO from "../../../../SEO/Seo";
import { metaContent } from "../../../../SEO/metaContent";

const Blog = () => {
  const navigate = useNavigate();
  useEffect(() => {
    // ✅ Select the static container
    const staticContainer = document.querySelector(".static-container");
    if (!staticContainer) return; // safeguard if not found

    // 🟢 Save old background before changing
    const oldBackground = staticContainer.style.backgroundImage;
    const oldBgColor = staticContainer.style.backgroundColor;
    const oldBgSize = staticContainer.style.backgroundSize;
    const oldBgRepeat = staticContainer.style.backgroundRepeat;
    const oldBgPosition = staticContainer.style.backgroundPosition;
    const oldBgAttachment = staticContainer.style.backgroundAttachment;

    // 🟣 Apply About Us background image
    staticContainer.style.backgroundImage = `url(${blogBg})`;
    staticContainer.style.backgroundSize = "cover";
    staticContainer.style.backgroundRepeat = "no-repeat";
    staticContainer.style.backgroundPosition = "center";
    // staticContainer.style.backgroundAttachment = "fixed";
    staticContainer.style.transition = "background 0.5s ease-in-out";

    // 🔴 Cleanup: restore old background when leaving AboutUs
    return () => {
      staticContainer.style.backgroundImage = oldBackground;
      staticContainer.style.backgroundColor = oldBgColor;
      staticContainer.style.backgroundSize = oldBgSize;
      staticContainer.style.backgroundRepeat = oldBgRepeat;
      staticContainer.style.backgroundPosition = oldBgPosition;
      staticContainer.style.backgroundAttachment = oldBgAttachment;
    };
  }, []);
  return (
    <>
      {/* Meta tags  */}
      <SEO {...metaContent.blog} />

      <div className="blog-container">
        <div className="text-center">
          <h2 className="hero-heading gradient-text">Knowledge</h2>
          <p className="hero-heading text-white">That Drives Growth.</p>
          <p className="hero-sub-text"> Our experts share proven insights, tips, and strategies to help sellers and brands scale smarter and faster.</p>
        </div>
        <div className="blog-grid-div">
          <div className="row g-5 mt-5">
            {blogs.map((blog) => (
              <div
                key={blog.id}
                className={`col-md-4 ${blog.id === "1" ? "with-overlay" : ""
                  }`}
              >
                <div className="blog-card h-100">
                  <img
                    src={blog.image}
                    alt={`blog ${blog.id}`}
                    className="blog-img img-fluid"
                  />

                  <div className="mt-2 mb-5">
                    <span className="blog-date">{blog.date || "Nov 01,2022"}</span>
                    <h3 className="blog-title">{blog.title}</h3>
                    <p className="blog-content">{blog.subtitle}</p>
                    <button
                      className="learn-more-btn text-center mt-1"
                      onClick={() => navigate(`/blog-details/${blog.id}`)}
                    >
                      Read More
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* <div className="" style={{padding: "6rem 9rem"}}> */}
      <Testimonial />
      {/* </div> */}

    </>
  );
};
export default Blog;
